import { TQueryParam, TRequestParams } from "../../../shared/commonTypes/commonTypes";

export function checkSearchParams(
    searchParams: URLSearchParams,
    paramsArr: TQueryParam[]
): { isValid: boolean; requestParams?: TRequestParams } {
    const requestParams = {} as TRequestParams;

    for (const param of paramsArr) {
        const value = searchParams.get(param);

        if (!value) {
            return { isValid: false };
        }

        requestParams[param] = value;
    }

    return {
        isValid: true,
        requestParams,
    };
}
